var _path, _path2, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocument = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08333 0.75H13.9167V11.655L9.72256 15.25H2.08333V0.75Z",
    stroke: "#EBBB59",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58333 4.6665C6.58333 5.35686 6.02369 5.9165 5.33333 5.9165C4.64298 5.9165 4.08333 5.35686 4.08333 4.6665C4.08333 3.97615 4.64298 3.4165 5.33333 3.4165C6.02369 3.4165 6.58333 3.97615 6.58333 4.6665Z",
    stroke: "#EBBB59",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.33333,
    y: 8,
    width: 8,
    height: 1,
    fill: "#EBBB59"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.33333,
    y: 10,
    width: 4,
    height: 1,
    fill: "#EBBB59"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.33333,
    y: 12,
    width: 4,
    height: 1,
    fill: "#EBBB59"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/document.9dd795a5d2b433fa8c538e41dbb4c9b3.svg";